import React from 'react';

import { makeStyles } from '@mui/styles';
import EventsStyles from '../EventsStyles';
import AddIcon from '@mui/icons-material/Add';
import { CONCEPT_SUBSCRIBER, PREDICATE_SUBSCRIBER, PERIOD_SCHEDULER, INFERENCE, FIXED_TIME_SCHEDULER } from '../EventsPage';

const useStyles = makeStyles({
  ...EventsStyles,
});

const CreateNewSub = ({ type, subName, onClick }) => {
  const classes = useStyles();

  return (
    <div className={classes.container} style={{ fontSize: 11 }} onClick={onClick}>
      <AddIcon className={classes.icon} />
      <span>Create&nbsp;</span>
      <span>
        {subName ? <strong>{subName}&nbsp;</strong> : null}
      </span>
      <span>{type === PREDICATE_SUBSCRIBER ? 'Predicate' : type === CONCEPT_SUBSCRIBER ? 'Concept' : type === FIXED_TIME_SCHEDULER ? '' : type === PERIOD_SCHEDULER ? '' : type === INFERENCE ? 'Inference' : null}&nbsp;{(type === FIXED_TIME_SCHEDULER || type === PERIOD_SCHEDULER )? 'Event' : 'Subscription'}</span>
    </div>
  );
};

export default CreateNewSub;
